module.exports = __webpack_public_path__ + "static/media/earnTribeExample.3876f036.png";